import React from 'react';
import PropTypes from 'prop-types';
import AlertMetadata from 'components/common/AlertOrMacroMetadata/AlertOrMacroMetadata';
import { AlertNote, AlertHeader, AlertTitle, AlertContent } from 'components/tools/alerts/Alerts.styles';
import { getReadStatusLabel, parseSanitizedAlertContent } from 'util/alertUtil';
import { AlertContainer, AlertReadMarker } from './Alert.styles';

const propTypes = {
  alert: PropTypes.shape({
    content: PropTypes.string.isRequired,
    note: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  renderAcknowledgeButton: PropTypes.func,
};

const Alert = ({ alert, renderAcknowledgeButton }) => {
  return (
    <AlertContainer>
      <AlertHeader>
        <div>
          <AlertMetadata resource={alert} />
          <AlertTitle>{alert.title}</AlertTitle>
          {alert.note && <AlertNote>{alert.note}</AlertNote>}
        </div>
        <AlertReadMarker>{getReadStatusLabel(alert)}</AlertReadMarker>
      </AlertHeader>
      <AlertContent {...parseSanitizedAlertContent(alert.content)} />
      {renderAcknowledgeButton && renderAcknowledgeButton()}
    </AlertContainer>
  );
};

Alert.propTypes = propTypes;

export default Alert;
